var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconArrowDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9994 19.833C13.7016 19.8315 13.4078 19.7637 13.1394 19.6346C12.871 19.5054 12.6348 19.3182 12.4477 19.0863L7.53608 13.1363C7.24907 12.7781 7.06846 12.3465 7.01483 11.8907C6.9612 11.4348 7.0367 10.973 7.23274 10.558C7.39174 10.1973 7.65119 9.88999 7.98013 9.67277C8.30907 9.45554 8.69358 9.3376 9.08774 9.33301H18.9111C19.3052 9.3376 19.6898 9.45554 20.0187 9.67277C20.3476 9.88999 20.6071 10.1973 20.7661 10.558C20.9621 10.973 21.0376 11.4348 20.984 11.8907C20.9304 12.3465 20.7498 12.7781 20.4627 13.1363L15.5511 19.0863C15.3641 19.3182 15.1278 19.5054 14.8594 19.6346C14.591 19.7637 14.2972 19.8315 13.9994 19.833Z",
    fill: "#292B30"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowDown);
export default __webpack_public_path__ + "static/media/icon-arrow-down.f15b95075a0e32a4793ea30b63da797d.svg";
export { ForwardRef as ReactComponent };